/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
/* eslint-disable quote-props */
import englishMessages from 'ra-language-english'
import { StringMap } from 'react-admin'

export const i18nNorwegian: StringMap = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra?.action,
      add_filter: 'Legg til filter',
      back: 'Tilbake',
      bulk_actions: '%{smart_count} valgt',
      cancel: 'Avbryt',
      clear_input_value: 'Tøm',
      clone: 'Klon',
      confirm: 'Bekreft',
      create: 'Opprett',
      delete: 'Slett',
      edit: 'Rediger',
      export: 'Eksporter',
      list: 'Liste',
      refresh: 'Oppdater',
      remove_filter: 'Fjern filter',
      remove: 'Fjern',
      save: 'Lagre',
      search: 'Søk',
      show: 'Vis',
      sort: 'Sorter',
      undo: 'Angre',
      unselect: 'Avmerk',
      disable: 'Deaktiver',
      enable: 'Aktiver',
    },
    boolean: {
      ...englishMessages.ra?.boolean,
      'true': 'Ja',
      'false': 'Nei',
    },
    page: {
      ...englishMessages.ra?.page,
      create: 'Opprett %{name}',
      dashboard: 'Kontrollpanel',
      edit: '%{name} #%{id}',
      error: 'Noe gikk galt',
      list: '%{name}',
      loading: 'Laster',
      not_found: 'Ikke funnet',
      show: '%{name} #%{id}',
    },
    notification: {
      ...englishMessages.ra?.notification,
      created: 'Opprettet',
      updated: 'Oppdatert',
      deleted: 'Slettet',
      bad_item: 'Ugyldig element',
      item_doesnt_exist: 'Elementet finnes ikke',
      http_error: 'Kommunikasjonsfeil med serveren',
      data_provider_error: 'Feil i dataleverandøren',
    },
    navigation: {
      ...englishMessages.ra?.navigation,
      no_results: 'Ingen resultater funnet',
      no_more_results: 'Side %{page} er utenfor grensene',
      page_out_of_boundaries: 'Side %{page} er utenfor grensene',
      page_out_from_end: 'Kan ikke gå forbi siste side',
      page_out_from_begin: 'Kan ikke gå før side 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} av %{total}',
      page_rows_per_page: 'Rader per side:',
      next: 'Neste',
      prev: 'Forrige',
      no_filtered_results: 'Ingen %{resource} funnet med gjeldende filtre.',
      clear_filters: 'Fjern filtre',
    },
    message: {
      ...englishMessages.ra?.message,
      about: 'Om',
      are_you_sure: 'Er du sikker?',
      yes: 'Ja',
      no: 'Nei',
      not_found: 'Feil URL eller du fulgte en ugyldig lenke.',
      loading: 'Siden laster, vennligst vent',
      invalid_form: 'Skjemaet er ikke gyldig. Sjekk for feil.',
      delete_title: 'Slett %{name} #%{id}',
      delete_content: 'Er du sikker på at du vil slette dette elementet?',
      details: 'Detaljer',
      error: 'En klientfeil oppstod og forespørselen din kunne ikke fullføres.',
      bulk_delete_title: 'Slett %{name} |||| Slett %{smart_count} %{name}',
      bulk_delete_content:
        'Er du sikker på at du vil slette dette %{name}? |||| Er du sikker på at du vil slette disse %{smart_count} elementene?',
    },
    input: {
      ...englishMessages.ra?.input,
      file: {
        upload_several: 'Dra og slipp filer, eller klikk for å velge.',
        upload_single: 'Dra og slipp en fil, eller klikk for å velge.',
      },
      image: {
        upload_several: 'Dra og slipp bilder, eller klikk for å velge.',
        upload_single: 'Dra og slipp et bilde, eller klikk for å velge.',
      },
    },
    validation: {
      ...englishMessages.ra?.validation,
      required: 'Påkrevd',
      minLength: 'Må være minst %{min} tegn',
      maxLength: 'Må være %{max} tegn eller færre',
      minValue: 'Må være minst %{min}',
      maxValue: 'Må være %{max} eller mindre',
      number: 'Må være et tall',
      email: 'Må være en gyldig e-postadresse',
    },
  },
  submenu: {
    beheer: 'Administrasjon',
    monitoring: 'Overvåking',
  },
  menu: {
    costExplorer: 'Kostnadsoversikt',
    applications: 'Applikasjoner',
    mcpServers: 'MCP-servere',
    proxies: 'Proxyer',
    organizations: 'Organisasjoner',
    automation: 'Automatisering',
    alerts: 'Varsler',
    auditLog: 'Revisjonslogg',
    accessRequests: 'Tilgangsforespørsler',
    platformRequests: 'Plattformforespørsler',
    requests: 'Foresporsler',
    workflows: 'Arbeidsflyter',
  },
  dashboard: {
    title: 'Kontrollpanel',
    loading: 'Laster kontrollpanel...',
    greeting: {
      morning: 'God morgen',
      afternoon: 'God ettermiddag',
      evening: 'God kveld',
    },
    description: 'Velkommen til xxllnc.ai.',
    statistics: 'statistikk',
    sectionPlatform: 'Platform',
    sectionTraffic: 'Trafikk',
    totalServers: 'MCP-servere',
    totalProxies: 'Proxyer',
    totalOrganizations: 'Organisasjoner',
    totalUsers: 'Brukere',
    mcpLinks: 'MCP-koblinger',
    proxyLinks: 'Proxy-koblinger',
    activeUsers: 'Aktive brukere',
    totalCalls: 'totalt antall kall',
    mcpToday: 'MCP i dag',
    mcpWeek: 'MCP denne uken',
    proxyToday: 'Proxy i dag',
    proxyWeek: 'Proxy denne uken',
    requestsToday: 'I dag',
    requestsThisWeek: 'Denne uken',
    errorRate: 'Feilrate',
    avgResponseTime: 'Responstid',
    sectionOverall: 'Totalt',
    activeAlerts: 'Aktive varsler',
    pendingAccessRequests: '%{count} ventende tilgangsforespørsel(er) venter på gjennomgang',
    pendingPlatformRequests: '%{count} ventende plattformforespørsel(er) venter på gjennomgang',
    review: 'Gjennomgå',
    topMcpOrganizations: 'Topp organisasjoner MCP (30 dager)',
    topProxyOrganizations: 'Topp organisasjoner Proxy (30 dager)',
    activeSeats: 'Aktive seter',
    topUsageOrgs: 'Topp bruksorganisasjoner (30 dager)',
    activeWorkflows: 'Aktive arbeidsflyter',
    recentExecutions: 'Utførelser (24t)',
    totalExecutions: 'totalt utførelser',
    popularMcps: 'Mest populære MCP-er',
    organizations: 'organisasjoner',
    calls: 'anrop',
    noData: 'Ingen data tilgjengelig',
    live: {
      lastHour: 'Siste time',
      now: 'Nå',
      last24h: 'Siste 24 t',
      calls: 'Kall',
      executions: 'Arbeidsflyt-kjøringer',
      activeUsers: 'Aktive brukere',
      errorRate: 'Feilrate',
      errors: 'Feil',
      trafficTitle: 'Trafikk',
      durationsTitle: 'Arbeidsflyt-varighet',
      avg: 'gj.sn.',
      noRuns: 'Ingen kjøringer i denne perioden',
      workflow: 'Arbeidsflyt',
      runs: 'Kjøringer',
      errorsCol: 'Feil',
      mcpErrorsTitle: 'MCP-servere med feil (nylig)',
      workflowErrorsTitle: 'Arbeidsflyter med feil (nylig)',
      weeklyArchive: 'Trafikk per uke',
    },
    capacity: {
      title: 'Kapasitet',
      mcp: 'MCP-trafikk',
      workflows: 'Arbeidsflyter',
      healthy: 'Komfortabel',
      busy: 'Travel',
      atLimit: 'På grensen',
      noPeak: 'ingen nylig topp',
      noDataTooltip: 'Ingen nylig data for å estimere kapasitet ennå.',
      headerTooltip:
        'Estimert plattformbelastning over de siste 7 dagene. Kapasiteten er beregnet for ' +
        '%{pods} pods med en gjennomsnittlig arbeidsflyt-varighet på %{seconds} sekunder.',
      mcpTooltip:
        'Topp per time: %{peak} forespørsler (%{peakAt}). Gjennomsnitt %{avg} per time. ' +
        'Kapasitet: %{ceiling} per time. Plattformen kan starte ekstra pods når lasten øker.',
      workflowTooltip:
        'Topp per time: %{peak} utførelser (%{peakAt}). Gjennomsnitt %{avg} per time. ' +
        'Kapasitet: %{ceiling} per time på %{pods} pods med en gjennomsnittlig varighet på %{seconds}s.',
    },
  },
  resources: {
    example: {
      list: 'Eksempler',
      create: 'Opprett eksempel',
      show: 'Eksempel',
    },
    application: {
      list: 'Applikasjoner',
      create: 'Opprett applikasjon',
      show: 'Applikasjon',
      edit: 'Rediger applikasjon',
      tabs: {
        environments: 'Miljøer',
        headers: 'Headere',
      },
    },
    application_environment: {
      name: 'Miljø',
    },
    mcp_server: {
      name: 'MCP-server |||| MCP-servere',
      list: 'MCP-servere',
      create: 'Opprett MCP-server',
      show: 'MCP-server',
      edit: 'Rediger MCP-server',
      tabs: {
        details: 'Detaljer',
        tools: 'Verktøy',
        links: 'Koblinger',
        logs: 'Logger',
        skills: 'Ferdigheter',
      },
    },
    proxy: {
      list: 'Proxyer',
      create: 'Opprett proxy',
      show: 'Proxy',
      edit: 'Rediger proxy',
      tabs: {
        setup: 'Oppsett',
        details: 'Detaljer',
        tools: 'Verktøy',
        links: 'Koblinger',
        logs: 'Logger',
      },
    },
    mcp_tool: {
      create: 'Opprett verktøy',
      edit: 'Rediger verktøy',
    },
    proxy_tool: {
      create: 'Opprett verktøy',
      edit: 'Rediger verktøy',
    },
    organization: {
      list: 'Organisasjoner',
      create: 'Opprett organisasjon',
      show: 'Organisasjon',
      edit: 'Rediger organisasjon',
      tabs: {
        details: 'Detaljer',
        users: 'Brukere',
        links: 'Koblinger',
        mcpLinks: 'MCP-koblinger',
        proxyLinks: 'Proxy-koblinger',
        workflowLinks: 'Arbeidsflyt-koblinger',
        usage: 'Bruk',
        identityProviders: 'Identitetsleverandorer',
        logs: 'Logger',
      },
      idp: {
        title: 'SSO-tilkoblinger',
        add: 'Legg til SSO',
        addTitle: 'Legg til identitetsleverandor',
        added: 'Identitetsleverandor lagt til',
        addFailed: 'Kunne ikke legge til identitetsleverandoren. Kontroller detaljene og prov igjen.',
        loadFailed: 'Kunne ikke laste SSO-tilkoblinger. Identitetsleverandoren kan vaere utilgjengelig.',
        providerType: 'Leverandortype',
        alias: 'Alias',
        displayName: 'Visningsnavn',
        empty: 'Ingen SSO-tilkoblinger konfigurert.',
        notProvisioned: 'Denne organisasjonen er enna ikke opprettet i identitetsleverandoren. Synkroniser organisasjoner forst.',
      },
    },
    organization_user: {
      create: 'Opprett bruker',
      edit: 'Rediger bruker',
    },
    organization_mcp_link: {
      create: 'Opprett MCP-kobling',
      edit: 'Rediger MCP-kobling',
    },
    organization_proxy_link: {
      create: 'Opprett proxy-kobling',
      edit: 'Rediger proxy-kobling',
    },
    organization_workflow_link: {
      create: 'Legg til arbeidsflyt-kobling',
      edit: 'Rediger arbeidsflyt-kobling',
      linkLabel: '%{org} → %{workflow}',
      costPerWorkflowExecution: 'Kostnad per kjøring (EUR, overstyring)',
      costPerWorkflowExecutionHelp:
        'Overstyr gebyret per kjøring for denne organisasjonens bruk av denne arbeidsflyten. '
        + 'La stå tomt for å arve fra arbeidsflyt- eller portal-standarden.',
      variablesTitle: 'Variabelverdier',
      variablesSubtitle:
        'Verdier denne organisasjonen oppgir for variablene arbeidsflyten refererer til via '
        + '{{ variables.X }}. La stå tomt for ingen verdi ved kjøretid.',
      variablesEmpty:
        'Denne arbeidsflyten refererer ikke til noen variabler. '
        + 'Variabler vises her så snart en node-parameter bruker {{ variables.<navn> }}.',
      variableHelper: 'Verdi for denne organisasjonen',
      serverConfigsTitle: 'Serverkonfigurasjon',
      serverConfigsSubtitle:
        'Per påkrevd MCP-server: hvilket miljø, mål-URL og seat denne organisasjonen bruker '
        + 'når arbeidsflyten kjøres.',
      serverConfigsEmpty:
        'Denne arbeidsflyten har ingen MCP-verktøysteg som trenger per-organisasjon-konfigurasjon.',
      environment: 'Miljø',
      environmentNone: 'Bruk server-standard',
      baseUrl: 'Mål-URL',
      seat: 'Seat (identitet)',
      seatNone: 'Bruk anroper-identitet',
      seatHelper:
        'Planlagte (cron) kjøringer kjører som denne seat, fordi de ikke har en utløsende bruker. '
        + 'Manuelle kjøringer kjører som brukeren som starter dem og MCP-kjøringer sender anroperen '
        + 'gjennom — la stå tomt i de tilfellene.',
    },
    automation_rule: {
      list: 'Automatiseringsregler',
      create: 'Opprett regel',
      show: 'Automatiseringsregel',
      edit: 'Rediger regel',
    },
    monitoring_rule: {
      name: 'Regel',
      tabs: {
        details: 'Detaljer',
        alerts: 'Varsler',
      },
    },
    monitoring_alert: {
      list: 'Varsler',
      show: 'Varsel',
    },
    documentUploads: {
      list: 'Dokumentopplastinger',
      show: 'Dokumentopplasting',
      upload: {
        button: 'Last opp dokument',
        title: 'Last opp dokument',
        success: 'Dokumentopplasting opprettet',
      },
      tabs: {
        details: 'Detaljer',
        logs: 'Logger',
      },
    },
  },
  auditLog: {
    timestamp: 'Tidspunkt',
    action: 'Handling',
    actor: 'Bruker',
    actorUserId: 'Bruker-ID',
    targetType: 'Måltype',
    targetId: 'Mål-ID',
    context: 'Detaljer',
    createdAfter: 'Fra',
    createdBefore: 'Til',
  },
  data: {
    costThisMonth: 'Kostnad denne måneden',
    usage: 'Forbruk',
    seats: 'Seter',
    mcpCostThisMonth: 'MCP-kostnad',
    proxyCostThisMonth: 'Proxy-kostnad',
    callsThisMonth: 'Anrop denne måneden',
    monthlyCosts: 'Månedlige kostnader',
    currentMonth: 'Gjeldende',
    noCostData: 'Ingen kostnadsdata tilgjengelig.',
    details: 'Detaljer',
    name: 'Navn',
    description: 'Beskrivelse',
    createdAt: 'Opprettet',
    lastModified: 'Sist endret',
    displayName: 'Navn',
    baseUrl: 'Base-URL',
    baseUrlHelp: 'La stå tom for å bruke serverens standard-URL.',
    authType: 'Autentiseringstype',
    headerName: 'Headernavn',
    headerValue: 'Headerverdi',
    headerType: 'Type',
    headerSource: 'Kilde',
    headerPrefix: 'Prefiks',
    headerPrefixHelp: 'Settes foran verdien, f.eks. "employee:"',
    headerCustomValue: 'Verdi',
    headerCreated: 'Header opprettet',
    headerUpdated: 'Header oppdatert',
    customHeadersOptional: 'Egendefinerte HTTP-headere (valgfritt)',
    customHeadersDescription: 'Egendefinerte HTTP-headere som sendes med forespørsler til denne applikasjonen.',
    costPer1000Calls: 'Kostnad per 1000 kall (€)',
    valueTypeCustom: 'Egendefinert',
    valueTypeOrganization: 'Organisasjon',
    valueTypeUser: 'Bruker',
    orgMetadataHelp: 'org.name, org.auth_id, eller org.metadata.<key>',
    headerValueSource: 'Verdi / Kilde',
    addHeader: 'Legg til',
    editHeader: 'Rediger header',
    addHeaderTitle: 'Legg til header',
    noHeaders: 'Ingen headere konfigurert.',
    deleteHeaderConfirm: 'Er du sikker på at du vil slette denne headeren?',
    headerEnvironments: 'Miljøer',
    headerEnvironmentsHelp: 'Velg hvilke miljøer denne headeren gjelder for. La stå tom for alle.',
    tokenParamsDescription: 'Ekstra parametere sendt i OAuth token-forespørselens body.',
    addTokenParam: 'Legg til',
    addTokenParamTitle: 'Legg til token-parameter',
    editTokenParam: 'Rediger token-parameter',
    noTokenParams: 'Ingen token-parametere konfigurert.',
    deleteTokenParamConfirm: 'Er du sikker på at du vil slette denne token-parameteren?',
    tokenParamCreated: 'Token-parameter opprettet',
    tokenParamUpdated: 'Token-parameter oppdatert',
    tokenParamName: 'Parameternavn',
    allEnvironments: 'Alle',
    userInterface: 'Brukergrensesnitt',
    token: 'Token',
    enabled: 'Aktiv',
    serverId: 'Server-ID',
    httpMethod: 'HTTP-metode',
    path: 'Sti',
    parameters: 'Parametere',
    paramName: 'Parameternavn',
    paramType: 'Type',
    required: 'Påkrevd',
    user: 'Bruker',
    noUser: 'Ingen bruker',
    username: 'Brukernavn',
    auth0Email: 'Auth0 e-postadresse',
    organizationId: 'Organisasjons-ID',
    mcpServer: 'MCP-server',
    userAccess: 'Brukertilgang',
    connectUrl: 'Tilkoblings-URL',
    users: 'Brukere',
    selectUser: 'Velg bruker',
    grantAccess: 'Aktiver',
    revokeAccess: 'Tilbakekall',
    seatUsersEmpty: 'Ingen seter funnet i denne organisasjonen',
    colUser: 'Bruker',
    colAccess: 'Tilgang',
    toolSource: 'Verktøykilde',
    toolSourceManual: 'Manuell',
    toolSourceOpenapi: 'OpenAPI-synkronisering',
    toolSourceOdata: 'OData-synkronisering',
    odataUrl: 'OData metadata-URL',
    odataUrlHelp: 'URL til $metadata-endepunktet (f.eks. https://api.example.com/odata/$metadata)',
    openapiUrl: 'OpenAPI JSON-URL',
    openapiUrlHelp: 'URL til OpenAPI JSON-spesifikasjonsfilen',
    openapiSource: 'OpenAPI-kilde',
    specUrl: 'Spesifikasjons-URL',
    specInputUrl: 'URL',
    specInputFile: 'Last opp fil',
    selectSpecFile: 'Velg spesifikasjonsfil',
    uploadSpecFile: 'Last opp ny spesifikasjonsfil',
    syncTools: 'Synkroniser',
    syncFailed: 'Synkronisering mislyktes',
    copied: 'Kopiert',
    copy: 'Kopier',
    copyUrl: 'Kopier URL',
    organization: 'Organisasjon',
    toolName: 'Verktøy',
    success: 'Suksess',
    proxy: 'Proxy',
    targetUrl: 'Mål-URL',
    searchLogs: 'Søk i logger...',
    searchTools: 'Søk i verktøy...',
    copyFailed: 'Kopiering mislyktes. Kopier manuelt.',
    enableAll: 'Aktiver alle',
    disableAll: 'Deaktiver alle',
    proxyId: 'Proxy-ID',
    auth0OrgId: 'Auth0 organisasjons-ID',
    searchAuth0User: 'Søk Auth0-bruker...',
    searchAuth0Org: 'Søk Auth0-organisasjon...',
    typeToSearch: 'Skriv for å søke...',
    noResults: 'Ingen resultater',
    application: 'Applikasjon',
    applicationType: 'Applikasjon',
    noApplicationType: 'Ingen applikasjon',
    interface: 'Grensesnitt',
    certificate: 'Sertifikat',
    downloadCert: 'Last ned sertifikat',
    downloadKey: 'Last ned privat nøkkel',
    generateCert: 'Generer sertifikat',
    regenerateCert: 'Regenerer sertifikat',
    ruleType: 'Type',
    logSource: 'Kilde',
    aggregation: 'Aggregering',
    operator: 'Operator',
    threshold: 'Terskel',
    windowMinutes: 'Tidsvindu (minutter)',
    cooldownMinutes: 'Avkjøling (minutter)',
    lastTriggered: 'Sist utløst',
    severity: 'Alvorlighetsgrad',
    acknowledged: 'Bekreftet',
    condition: 'Betingelse',
    actions: 'Handlinger',
    ruleTypeCustom: 'Egendefinert',
    ruleTypeFairUse: 'Fair Use',
    logSourceAll: 'Alle',
    logSourceMcp: 'MCP',
    logSourceProxy: 'Proxy',
    allOrganizations: 'Alle organisasjoner',
    acknowledge: 'Bekreft',
    title: 'Tittel',
    status: 'Status',
    statusAvailable: 'Tilgjengelig',
    statusInactive: 'Inaktiv',
    blockedUntil: 'Blokkert til %{date}',
    mcpCalls: 'MCP-anrop',
    proxyCalls: 'Proxy-anrop',
    workflowExecutions: 'Arbeidsflyt-utførelser',
    statMcpServers: 'MCP-servere',
    statProxies: 'Proxyer',
    statHeaders: 'Headere',
    statTools: 'Verktøy',
    statLinks: 'Koblinger',
    statSkills: 'Ferdigheter',
    statusExpired: 'Utløpt',
    statusDownloaded: 'Lastet ned',
    singleUse: 'Engangsbruk',
    downloaded: 'Lastet ned',
    expiresAt: 'Utløper',
    created: 'Opprettet',
    createdBy: 'Opprettet av',
    visibility: 'Synlighet',
    visibilityPersonal: 'Personlig',
    visibilityShared: 'Delt',
    authTypeNone: 'Ingen',
    authTypeOauthClientCredentials: 'OAuth client credentials',
    authTypeClientCertificate: 'Klientsertifikat',
    authTypeCustomHeaders: 'Egendefinerte headere',
    authTypePassword: 'Passord',
    authTypeAuth0: 'Auth0',
    auth0User: 'Auth0-bruker',
    password: 'Passord',
    expiration: 'Utløpstid',
    expiration1Day: '1 dag',
    expiration7Days: '7 dager',
    expiration30Days: '30 dager',
    expirationNever: 'Aldri',
    selectFiles: 'Velg filer',
    files: 'Filer',
    downloadLogs: 'Last ned logger',
    downloaderIdentity: 'Nedlaster',
    errorMessage: 'Feilmelding',
    ipAddress: 'IP-adresse',
    addSource: 'Legg til API-kilde',
    addSourceName: 'Navn',
    addSourceType: 'Type',
    addSourceSpecUrl: 'Spesifikasjons-URL',
    addSourceSpecUrlHelp: 'URL til OpenAPI JSON/YAML eller OData $metadata',
    addSourceSubmit: 'Legg til',
    addSourceSuccess: 'API-kilde lagt til og synkronisert',
    sourceDeleted: 'API-kilde slettet',
    syncResult: 'Synk: %{created} nye, %{updated} oppdatert, %{disabled} deaktivert',
    manualTools: 'Manuelle verktøy',
    noToolsFound: 'Ingen verktøy funnet',
    noTools: 'Ingen verktøy',
    hideDisabled: '%{count} deaktivert',
    modified: 'Endret',
    deleteSource: 'Slett',
    other: 'Annet',
    logLevel: 'Loggnivå',
    testFailed: 'Test mislyktes',
    sync: 'Synk',
    orgSyncResult:
      'Synkronisering fullført: %{created} opprettet, %{updated} oppdatert, ' +
      '%{deleted} slettet, %{reactivated} reaktivert',
    metadataFields: 'Egendefinerte metadata-felt',
    metadataKey: 'Nøkkel',
    metadataValue: 'Verdi',
    deletedBanner: 'Denne organisasjonen er slettet fra Auth0. Ingen nye koblinger eller brukere kan legges til.',
    marketplaceVisible: 'Synlig i markedsplassen',
    mcpUrlSlug: 'URL-slug',
    mcpUrlSlugHelp: 'URL-banen for denne MCP (f.eks. /mcp/min_server). Endring vil bryte eksisterende tilkoblinger.',
    mcpAbout: 'Om denne MCP (portal)',
    projectInstructions: 'Prosjektinstruksjoner (CLAUDE.md / GEMINI.md)',
    projectInstructionsHelp: 'Instruksjoner som brukere kopierer til prosjektkonfigurasjonen sin',
    advancedSettings: 'Avanserte innstillinger',
    isDemo: 'Demo MCP',
    isDemoHelp:
      'Demo MCP-er kan aktiveres i portalen uten godkjenning og kobles automatisk til nye gratisorganisasjoner.',
    defaultBaseUrl: 'Standard mål-URL',
    defaultBaseUrlHelp: 'Brukes som base-URL ved opprettelse av koblinger. Påkrevd for Demo MCP-er.',
    defaultEnvironment: 'Standard miljø',
    defaultEnvironmentHelp: 'Miljø som brukes ved automatisk godkjenning. Påkrevd når automatisk godkjenning er aktivert.',
    autoApproveAccess: 'Automatisk godkjenning av tilgangsforespørsler',
    skillLinked: 'Ferdighet koblet',
    skillUnlinked: 'Ferdighet frakoblet',
    skillUpdated: 'Ferdighet oppdatert',
    skillCreatedLinked: 'Ferdighet opprettet og koblet',
    skillEdit: 'Rediger',
    skillUnlink: 'Koble fra',
    skillLinkExisting: 'Koble eksisterende ferdighet',
    skillAdd: 'Legg til',
    skillNew: 'Ny ferdighet',
    skillsShared: 'Ferdigheter deles mellom MCP-servere. Endringer i en ferdighet gjelder overalt den er koblet.',
    skillsEmpty: 'Ingen ferdigheter koblet ennå. Koble en eksisterende ferdighet eller opprett en ny.',
    skillsAllLinked: 'Alle ferdigheter er allerede koblet til denne serveren.',
    skillsAllLinkedForApp: 'Alle ferdigheter for denne applikasjonen er koblet. Fjern filteret for å se andre ferdigheter.',
    skillFilterAllApps: 'Alle applikasjoner',
    skillLinkedTo: 'Koblet til %{count} servere',
    skillDialogEdit: 'Rediger ferdighet',
    skillDialogNew: 'Ny ferdighet',
    skillApplication: 'Applikasjon',
    skillNoApplication: 'Ingen applikasjon (global)',
    skillName: 'Navn',
    skillDescription: 'Beskrivelse (valgfritt)',
    skillContent: 'Innhold',
    skillCancel: 'Avbryt',
    skillSave: 'Lagre',
    skillCreate: 'Opprett',
    skillClose: 'Lukk',
    skillCustom: 'Tilpasset',
    tokenUrl: 'Token-URL',
    clientId: 'Klient-ID',
    clientSecret: 'Klienthemmelighet',
    audience: 'Publikum',
    certificatePem: 'Klientsertifikat (PEM)',
    certificatePemHelp: 'PEM-kodet klientsertifikat',
    privateKeyPem: 'Privatnøkkel (PEM)',
    privateKeyPemHelp: 'PEM-kodet privatnøkkel (ukryptert)',
    environment: 'Miljø',
    environments: 'Miljøer',
    addEnvironment: 'Legg til miljø',
    editEnvironment: 'Rediger miljø',
    deleteEnvironmentConfirm: 'Er du sikker på at du vil slette dette miljøet?',
    noEnvironments: 'Ingen miljøer konfigurert.',
    environmentAuthHelp: 'Autentiseringsdetaljer konfigureres per miljø.',
    environmentCreated: 'Miljø opprettet',
    environmentUpdated: 'Miljø oppdatert',
    envStatusActive: 'Aktiv',
    envStatusDisabled: 'Deaktivert',
    noEnvironmentsHint: 'Legg til et miljø for å konfigurere autentiseringsdetaljer.',
    identitySection: 'Identitet',
    authenticationSection: 'Autentisering',
    toolEdit: 'Rediger verktøy',
    toolUpdated: 'Verktøy oppdatert',
    toolSaveFailed: 'Lagring mislyktes',
    toolEnabled: 'Aktivert',
    toolDisabled: 'Deaktivert',
    toolParameters: 'Parametere',
    toolParameter: 'Parameter',
    toolEnum: 'Enum:',
    workflows: 'Arbeidsflyter',
    mcpHealth: 'MCP Helse',
    healthy: 'Sunn',
    warning: 'Advarsel',
    error: 'Feil',
    noRecentWorkflows: 'Ingen nylige arbeidsflytutførelser',
    noMcpLinks: 'Ingen MCP-koblinger',
    downloadUrl: 'Nedlastings-URL',
    severityCritical: 'Kritisk',
    severityWarning: 'Advarsel',
    severityInfo: 'Info',
    workflow: 'Arbeidsflyt',
    triggeredBy: 'Utløst av',
    triggerType: 'Utløsertype',
  },
  costExplorer: {
    title: 'Kostnadsoversikt',
    totalCosts: 'Totale kostnader',
    seatCosts: 'Setekostnader',
    mcpSlotCosts: 'MCP-plasskostnader',
    workflowSlotCosts: 'Arbeidsflyt-plasskostnader',
    workflowExecutionCosts: 'Arbeidsflyt-utførelseskostnader',
    platformCosts: 'Plattformkostnader',
    chatCosts: 'Chatkostnader',
    periodCurrentMonth: 'Denne måneden',
    period3m: '3 måneder',
    period6m: '6 måneder',
    period12m: '12 måneder',
    periodAll: 'All tid',
    organization: 'Organisasjon',
    allOrganizations: 'Alle organisasjoner',
    costTimeline: 'Kostnadstidslinje',
    organizationBreakdown: 'Organisasjonsoversikt',
    seats: 'Seter',
    mcpSlots: 'MCP-plasser',
    workflowSlots: 'Arbeidsflyt-plasser',
    total: 'Totalt',
    calls: 'Kall',
    cost: 'Kostnad',
    serverBreakdown: 'Kostnad per MCP-server',
    proxyBreakdown: 'Kostnad per proxy',
    workflowBreakdown: 'Kostnad per arbeidsflyt',
    workflow: 'Arbeidsflyt',
    proxy: 'Proxy',
    executions: 'Kjøringer',
    executionCost: 'Kjøringskostnad',
    aiTokens: 'AI-tokens',
    aiCostEstimated: 'AI-kostnad (est.)',
    avgPerDay: 'Gj.snitt per dag',
    vsLastPeriod: 'vs forrige periode',
  },
  settings: {
    title: 'Innstillinger',
    description: 'Administrer dine personlige preferanser',
    saved: 'Innstillinger lagret',
    organization: 'Organisasjon',
    organizationName: 'Navn',
    organizationAuthId: 'Organisasjons-ID',
    section: {
      language: 'Sprak',
      appearance: 'Utseende',
      about: 'Om',
    },
    languageTitle: 'Sprak',
    languageDescription: 'Velg sprak for grensesnittet',
    appearanceTitle: 'Utseende',
    appearanceDescription: 'Tilpass applikasjonens utseende',
    filtersOpen: 'Filtre apne som standard',
    filtersOpenHelp: 'Vis filterpanelet automatisk pa listesider',
    rowsPerPage: 'Rader per side',
    aboutTitle: 'Om denne applikasjonen',
    userName: 'Navn',
    userEmail: 'E-post',
    appVersion: 'Versjon',
  },
  login: {
    title: 'Administrasjon',
    button: 'Fortsett',
    email: 'navn@jobb-epost.com',
    emailLabel: 'E-postadresse',
    emailHint: 'Logg inn for å fortsette.',
    hint: 'Logg inn på xxllnc.ai',
    notValid: 'Den oppgitte e-postadressen er ikke gyldig',
    byXxllnc: 'xxllnc.ai er en applikasjon fra xxllnc',
    inactive: 'Du ble logget ut på grunn av inaktivitet.',
    selectOrganization: 'Velg organisasjonen din',
    noOrganization: 'Ingen organisasjon funnet for dette e-postdomenet.',
    back: 'Tilbake',
    loading: 'Søker etter organisasjoner...',
    lookingFor: 'Ser du etter xxllnc.ai-brukerinnloggingen?',
    signInToHub: 'Logg inn på xxllnc.ai for organisasjonen din',
    changeRegion: 'Endre region',
    noAdminAccess: 'Ingen admin-tilgang',
    noAdminAccessHint:
      'Du er logget inn, men kontoen din har ikke tilgang til admin-dashbordet. ' +
      'Logg ut for å prøve en annen konto, eller gå til MCP Hub.',
    noAdminAccessAction: 'Logg ut og bruk en annen konto',
  },
  proxySetup: {
    title: 'Proxy-konfigurasjon',
    intro: 'Følg trinnene nedenfor for å konfigurere denne proxyen for API-tilgang.',
    step1Title: 'Proxy base-URL',
    step1Description:
      'Bruk denne base-URL-en etterfulgt av stien til mål-API-et. ' +
      'Autentiser med et klientsertifikat (mTLS). Last ned sertifikatet og den private nøkkelen fra organisasjonskoblingen.',
    step2Title: 'Test tilkoblingen',
    step2Description:
      'Bruk curl-kommandoen nedenfor for å teste proxyen. Erstatt ' +
      '{sti-til-api} med ønsket API-sti. Bruk klientsertifikatet og den private nøkkelen fra organisasjonskoblingen.',
    curlComment: '# Test proxy-tilkoblingen med klientsertifikat',
  },
  usageChart: {
    daily: 'Per dag',
    monthly: 'Per måned',
    noData: 'Ingen bruksdata tilgjengelig',
    loadError: 'Feil ved innlasting av bruksdata',
  },
  logsChart: {
    total: 'Totalt',
    errors: 'Feil',
    period24h: '24 timer',
    period7d: '7 dager',
    period30d: '30 dager',
  },
  delete: {
    confirmTitle: 'Bekreft sletting',
    confirmContentMcp:
      'Er du sikker på at du vil slette denne MCP-serveren? ' +
      'Alle tilknyttede organisasjonskoblinger, brukertilgang og logger vil også bli slettet.',
    confirmContentProxy:
      'Er du sikker på at du vil slette denne proxyen? ' +
      'Alle tilknyttede organisasjonskoblinger, brukertilgang og logger vil også bli slettet.',
    confirmContentOrganization:
      'Er du sikker på at du vil slette denne organisasjonen? ' +
      'Alle brukere, koblinger og logger vil også bli slettet.',
    confirmContentDocument:
      'Er du sikker på at du vil slette denne dokumentopplastingen? ' +
      'Alle filer og nedlastingslogger vil også bli slettet.',
    confirmContentUser: 'Er du sikker på at du vil slette denne brukeren?',
    confirmContentMcpLink:
      'Er du sikker på at du vil slette denne MCP-koblingen? ' +
      'All brukertilgang vil også bli slettet.',
    confirmContentProxyLink: 'Er du sikker på at du vil slette denne proxy-koblingen?',
    confirmContentMonitoringRule:
      'Er du sikker på at du vil slette denne overvåkingsregelen? ' +
      'Alle tilknyttede varsler vil også bli slettet.',
    confirmContentWorkflow:
      'Er du sikker på at du vil slette denne arbeidsflyten? Alle tilknyttede ' +
      'organisasjonskoblinger og utforelser vil også bli slettet.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Ikke autorisert',
      defaultTitle: 'Ikke autorisert',
      title: 'Du er ikke autorisert for denne handlingen.',
      text: 'Du har forsøkt å utføre en handling du ikke har rettigheter til.',
    },
    noPermissions: {
      title: 'Ingen rettigheter tildelt',
      text:
        'Kontoen din har tilgang til dashbordet, men har ingen spesifikke '
        + 'rettigheter. Be en plattformadministrator om å tilordne '
        + 'sa.*-rollene (eller admin_full-kompositten) du trenger.',
    },
  },
  orgMembers: {
    noAuth0Org: 'Denne organisasjonen har ingen Auth0-org koblet.',
    noMembers: 'Ingen medlemmer funnet i Auth0 for denne organisasjonen.',
    name: 'Navn',
    email: 'E-post',
    roles: 'Roller',
    seat: 'Sete',
    chat: 'Chat',
    seatYes: 'Aktiv',
    seatNo: 'Ingen sete',
    chatOn: 'På',
    chatOff: 'Av',
    beheerder: 'Administrator',
    assignSeat: 'Tildel sete',
    removeSeat: 'Fjern sete',
    makeBeheerder: 'Gjør til administrator',
    removeBeheerder: 'Fjern administrator',
    seatAssigned: 'Sete tildelt',
    seatRemoved: 'Sete fjernet',
    beheerderAssigned: 'Administratorrolle tildelt',
    beheerderRemoved: 'Administratorrolle fjernet',
    installInChat: 'Installer i Chat',
    removeFromChat: 'Fjern fra Chat',
    chatInstalled: 'Bruker installert i Chat',
    chatRemoved: 'Bruker fjernet fra Chat',
    actionFailed: 'Handling mislyktes. Prøv igjen.',
  },
  portalBranding: {
    title: 'Styling',
    menuTitle: 'Styling',
    description: 'Konfigurer stylingen til portalene. Farger, logo og titler vises for alle brukere.',
    noConfig: 'Ingen merkevare-konfigurasjon ennå. Lagre for å opprette.',
    saved: 'Innstillinger lagret',
    section: {
      colors: 'Farger',
      header: 'Topptekst',
      typography: 'Typografi og form',
      secureAccessBranding: 'xxllnc.ai merkevare',
      mcpHubBranding: 'MCP Hub merkevare',
    },
    primaryColor: 'Primærfarge',
    primaryColorHelp: 'Hovedfarge for knapper og aksenter, f.eks. #28282C',
    secondaryColor: 'Sekundærfarge',
    secondaryColorHelp: 'Aksentfarge, f.eks. #E86E44',
    loginBgColor: 'Bakgrunnsfarge for innlogging',
    loginBgColorHelp: 'Bakgrunn på innloggingssiden',
    bgColor: 'Sidebakgrunn',
    bgColorHelp: 'Bakgrunn for portalen (standard: #fafafa)',
    headerColor: 'Bakgrunnsfarge for topptekst',
    headerColorHelp: 'Standard: hvit',
    headerTextColor: 'Tekstfarge for topptekst',
    headerTextColorHelp: 'Bruk lys farge (#ffffff) for mørke topptekster',
    fontFamily: 'Skrifttype',
    fontFamilyHelp: 'Google Fonts-navn, f.eks. Inter eller Roboto. Tom = DM Sans',
    borderRadius: 'Hjørneavrunding (0-20)',
    borderRadiusHelp: '0 = skarp/profesjonell, 10 = standard, 20 = avrundet',
    adminTitle: 'Administrasjonsportaltittel',
    adminTitleHelp: 'Tittel vist i toppteksten til xxllnc.ai administrasjonsportalen',
    portalTitle: 'Portaltittel',
    portalTitleHelp: 'F.eks. MCP Hub',
    loginSubtitle: 'Undertittel for innloggingssiden',
    loginSubtitleHelp: 'Kort velkomsttekst på innloggingssiden (maks 200 tegn)',
    logoUrl: 'Logo',
    logoUrlHelp: 'URL til logoen (bilde)',
    faviconUrl: 'Favicon',
    faviconUrlHelp: 'URL til faviconet',
    uploadImage: 'Last opp bilde',
    changeImage: 'Endre bilde',
    enabled: 'Egendefinert branding aktiv',
  },
  portalSettings: {
    title: 'Portalinnstillinger',
    menuTitle: 'Portalinnstillinger',
    description: 'Konfigurer plattforminnstillinger, nivågrenser, funksjoner og portalmerking.',
    saved: 'Innstillinger lagret',
    section: {
      branding: 'Merkevare',
      tiers: 'Nivågrenser',
      features: 'Funksjoner',
      defaults: 'Kostnadsstandarder',
      chat: 'Chat',
      importExport: 'Import / Eksport',
    },
    chat: {
      description:
        'Aktiver eller deaktiver enkelte chatmodeller. Aktiverte modeller kan brukes '
        + 'av alle chatbrukere; deaktiverte modeller er kun for administratorer.',
      enabled: 'Aktivert',
      disabled: 'Deaktivert',
      enabledCount: '{count} av {total} modeller aktivert',
      loadFailed: 'Kunne ikke laste modeller.',
      updateFailed: 'Kunne ikke oppdatere modellen. Prov igjen.',
      retry: 'Prov igjen',
      empty: 'Ingen chatmodeller er tilgjengelige enna.',
    },
    branding: {
      description: 'Konfigurer stylingen til MCP Hub-portalen. Farger, logo og titler vises for alle portalbrukere.',
    },
    importExport: {
      description: 'Pakk og migrer plattformkonfigurasjon. Sensitive opplysninger inkluderes aldri.',
      export: {
        title: 'Eksporter konfigurasjon',
        description: 'Lag en overførbar JSON-bunt med applikasjoner, MCP-servere og workflows.',
        button: 'Eksporter konfigurasjon…',
        modalTitle: 'Eksporter konfigurasjon',
        modalIntro: 'Velg hva som skal inkluderes. Avhengigheter legges til automatisk '
          + '— en MCP-server tar med seg applikasjonen, en workflow tar med seg servere og applikasjoner.',
        applications: 'Applikasjoner',
        mcpServers: 'MCP-servere',
        workflows: 'Workflows',
        modeNone: 'Ingen',
        modeAll: 'Alle',
        modeSelected: 'Velg…',
        includeDependencies: 'Inkluder avhengigheter automatisk',
        downloadButton: 'Last ned bunt',
        cancel: 'Avbryt',
        emptySelection: 'Velg minst ett element for å eksportere.',
      },
      import: {
        title: 'Importer konfigurasjon',
        description: 'Bruk en tidligere eksportert bunt på denne instansen.',
        dropzone: 'Slipp en .json-bunt her eller klikk for å bla',
        dropzoneActive: 'Slipp for å laste bunten',
        invalidFile: 'Kun .json-bunter støttes.',
        previewTitle: 'Gjennomgå import',
        previewIntro: 'Gjennomgå hva som blir opprettet, oppdatert eller hoppet over før du bruker.',
        sectionApplications: 'Applikasjoner',
        sectionSkills: 'Ferdigheter',
        sectionMcpServers: 'MCP-servere',
        sectionWorkflows: 'Workflows',
        chipNew: 'Ny',
        chipExists: 'Finnes',
        toggleAll: 'Veksle alle',
        decisionCreate: 'Opprett',
        decisionSkip: 'Hopp over',
        decisionOverwrite: 'Overskriv',
        dependsOn: 'Krever %{names}',
        warningHeader: 'Advarsler',
        executeButton: 'Importer (%{count})',
        cancel: 'Avbryt',
        successCounts: '%{created} opprettet · %{updated} oppdatert · %{skipped} hoppet over · %{failed} mislyktes',
        emptyBundle: 'Denne bunten inneholder ingen elementer.',
        previewing: 'Leser bunt…',
      },
      lastImport: {
        title: 'Siste import',
        description: 'Den seneste importen som ble brukt på denne instansen.',
        emptyState: 'Ingen import er registrert ennå.',
        by: 'av %{actor}',
        bundle: 'Bunt: %{filename}',
        statCreated: 'opprettet',
        statUpdated: 'oppdatert',
        statSkipped: 'hoppet over',
        statFailed: 'mislyktes',
      },
    },
    tiers: {
      description: 'Konfigurer MCP-plasser og setegrenser per nivå. Disse grensene gjelder plattformvidt.',
      mcpSlots: 'MCP-plasser',
      seatMax: 'Maks seter',
      approval: 'Godkjenning',
      autoApprove: 'Automatisk godkjenning av gratisnivå for nye organisasjoner',
    },
    features: {
      description: 'Aktiver eller deaktiver plattformfunksjoner globalt.',
      chatEnabled: 'Chat (Open WebUI) aktivert',
      authTitle: 'Autentisering',
      beheerderRole: 'Administratorrolle',
      beheerderRoleHelp: 'Velg Keycloak realm-rollen som identifiserer portaladministratorer.',
      selectScope: 'Velg det nødvendige omfanget for administratortilgang:',
    },
    defaults: {
      description: 'Standard kostnadsverdier for nye organisasjoner. Kan overstyres per organisasjon.',
      costPerSeat: 'Kostnad per sete',
      costPerMcp: 'Kostnad per MCP-plass',
      costPerWorkflow: 'Kostnad per arbeidsflyt-plass',
      costPerWorkflowExecution: 'Kostnad per arbeidsflyt-kjøring',
      costPerWorkflowExecutionHelp:
        'Belastes for hver arbeidsflyt-kjøring når verken arbeidsflyten selv eller en '
        + 'organisasjon-arbeidsflyt-kobling har egen sats.',
      aiQuotaEurPerHour: 'AI-timegrense',
      aiQuotaEurPerHourHelp:
        'Hard timegrense på AI-forbruk i arbeidsflyter når en organisasjon ikke har egen overstyring.',
      platformBudget: 'Plattformbudsjett',
      workflowBudget: 'Arbeidsflyt-budsjett',
      chatBudget: 'Chatbudsjett',
    },
    litellm: {
      title: 'LiteLLM forbruksimport',
      description:
        'Én LiteLLM-API-nøkkel med management-tilgang som henter AI-forbruket for alle '
        + 'organisasjoner hvert ~10. minutt. Hver org matches på sin lagrede LiteLLM-key-id.',
      status: 'Status:',
      configured: 'Konfigurert',
      notConfigured: 'Ikke konfigurert',
      keyLabel: 'Management API-nøkkel',
      keyHelp:
        'Lim inn en management-nøkkel for å sette eller erstatte den. La stå tom for å beholde '
        + 'den nåværende nøkkelen.',
    },
    capacity: {
      title: 'Plattformkapasitet',
      description:
        'Tak som brukes av kapasitets-widgeten og de automatiske varselreglene. ' +
        'Juster når du legger til pods eller endrer gjennomsnittlig arbeidsflyt-varighet.',
      mcpHourCeiling: 'MCP-kapasitet per time',
      mcpHourCeilingHelp:
        'Maksimalt antall MCP-forespørsler per time med varm cache og gjeldende pod-konfigurasjon.',
      workflowPods: 'Antall pods',
      workflowPodsHelp:
        'Antall aktive secureaccess-api pods (Helm maxReplicas). Sammen med gjennomsnittlig varighet styrer dette arbeidsflyt-grensen.',
      avgWorkflowSeconds: 'Gjennomsnittlig varighet (sekunder)',
      avgWorkflowSecondsHelp:
        'Forventet gjennomsnittlig varighet per arbeidsflyt-utførelse. Grense = pods × 50 slots × 3600 ÷ varighet.',
      alertThresholdPct: 'Varselgrense (%)',
      alertThresholdPctHelp:
        'Sender et varsel når toppbelastningen krysser denne prosentdelen av kapasiteten.',
    },
  },
  platformRequest: {
    filters: {
      status: 'Status',
      tier: 'Nivå',
    },
    status: {
      pending: 'Under behandling',
      approved: 'Godkjent',
      denied: 'Avslått',
    },
    tier: {
      free: 'Free',
      team: 'Team',
      enterprise: 'Enterprise',
    },
    fields: {
      organization: 'Organisasjon',
      tier: 'Nivå',
      requester: 'Forespørrer',
      status: 'Status',
      date: 'Dato',
      actions: 'Handlinger',
    },
    approve: 'Godkjenn',
    deny: 'Avslå',
    denyDialog: {
      title: 'Avslå forespørsel',
      reason: 'Årsak',
      cancel: 'Avbryt',
    },
  },
  automationRule: {
    scope: 'Omfang',
    scopeGlobal: 'Alle organisasjoner',
    scopeSpecific: 'Spesifikke organisasjoner',
    tiers: 'Nivåer',
    organizations: 'Organisasjoner',
    triggers: 'Utløsere',
    actions: 'Handlinger',
    loading: 'Laster...',
    tabs: {
      details: 'Detaljer',
      alerts: 'Varsler',
    },
    test: 'Test',
    titleCreate: 'Ny automatisering',
    titleEdit: 'Rediger automatisering',
    created: 'Regel opprettet',
    updated: 'Regel oppdatert',
    saveFailed: 'Lagring mislyktes',
    tierFilter: 'Nivåfilter',
    validation: {
      nameRequired: 'Navn er påkrevd',
      triggerRequired: 'Legg til minst 1 utløser',
      actionRequired: 'Legg til minst 1 handling',
    },
    flow: {
      when: 'NÅR',
      then: 'SÅ',
      done: 'FERDIG',
      addTrigger: 'Legg til utløser',
      addAction: 'Legg til handling',
      triggerChip: 'UTLØSER',
      actionChip: 'HANDLING',
    },
    settings: {
      label: 'INNSTILLINGER',
      subtitle: 'Omfang, nedkjøling & status',
      cooldownHelp: 'Minimum tid mellom to aktiveringer (0 = ingen grense)',
    },
    picker: {
      configuration: 'Konfigurasjon',
      addToFlow: 'Legg til i flyt',
      triggerHint: 'Når skal denne regelen aktiveres?',
      actionHint: 'Hva skal skje?',
    },
  },
  accessRequest: {
    search: 'Søk',
    status: {
      pending: 'Under behandling',
      approved: 'Godkjent',
      denied: 'Avslått',
    },
    requestType: {
      organization: 'Organisasjon',
      user: 'Bruker',
    },
    fields: {
      requester: 'Forespørrer',
      mcpServer: 'MCP-server',
      organization: 'Organisasjon',
      type: 'Type',
      environment: 'Miljø',
      status: 'Status',
      date: 'Dato',
      actions: 'Handlinger',
      environmentUrl: 'Miljø-URL',
      environmentName: 'Miljø',
      message: 'Melding',
    },
    approve: 'Godkjenn',
    createLink: 'Opprett kobling',
    deny: 'Avslå',
    denyDialog: {
      title: 'Avslå forespørsel',
      reason: 'Årsak',
      cancel: 'Avbryt',
    },
    noExtraInfo: 'Ingen tilleggsinformasjon for denne forespørselen.',
  },
  openwebuiConfig: {
    sectionLitellm: 'LiteLLM',
    sectionLitellmHelp: 'LLM-gateway: API-nøkkel og nøkkeldata som ruter chat-trafikk.',
    sectionOpenwebui: 'Open WebUI',
    sectionOpenwebuiHelp: 'Chat-grensesnittet: instans-URL og admin-API-nøkkel for brukeradministrasjon.',
    litellmApiKey: 'LiteLLM API-nøkkel',
    litellmApiKeyHelp: 'F.eks. sk-zOUVjchU...',
    keyName: 'Nøkkelnavn',
    keyNameHelp: 'Lesbart navn på nøkkelen i LiteLLM',
    keyId: 'Nøkkel-ID',
    keyIdHelp: 'Intern nøkkel-hash/ID fra LiteLLM',
    openwebuiUrl: 'Open WebUI URL',
    openwebuiUrlHelp: 'Offentlig URL for Open WebUI-instansen for denne organisasjonen',
    openwebuiApiKey: 'Open WebUI API-nøkkel',
    openwebuiApiKeyHelp: 'Admin API-nøkkel for brukeradministrasjon i Open WebUI',
    enabled: 'Aktiv',
    enabledTierHelp: 'Kun tilgjengelig på Enterprise (produksjon)-nivået.',
    tierWarning: 'Chat kan kun aktiveres for organisasjoner på Enterprise (produksjon)-nivået. '
      + 'Endre nivået til Enterprise for å aktivere chat.',
    descriptionExisting: 'Chat-konfigurasjon for denne organisasjonen.',
    descriptionNew: 'Ingen chat-konfigurasjon ennå. Lagre for å opprette.',
  },
  organizationCosts: {
    costPerSeat: 'Kostnad per plass (EUR/måned)',
    costPerSeatHelp: 'La stå tomt for standard (EUR 15,00)',
    costPerMcp: 'Kostnad per MCP (EUR/måned)',
    costPerMcpHelp: 'La stå tomt for standard (EUR 25,00)',
    costPerWorkflow: 'Kostnad per arbeidsflyt (EUR/måned)',
    costPerWorkflowHelp: 'La stå tomt for portal-standard',
    aiQuotaEurPerHour: 'AI-budsjett per time (EUR)',
    aiQuotaEurPerHourHelp: 'Hard grense på AI-forbruk per time for denne organisasjonen. La stå tomt for portal-standard.',
  },
  logs: {
    time: 'Tid',
    noLogs: 'Ingen logger funnet',
    statusOk: 'OK',
    statusError: 'Feil',
    bodyPreview: 'Forhåndsvisning av responskropp',
    detailStatus: 'Status',
    detailUrl: 'URL',
    detailResponseTime: 'Responstid',
    detailError: 'Feil',
  },
  requests: {
    mcpRequest: 'MCP-tilgang',
    workflowRequest: 'Arbeidsflyt',
    workflowGenerationRequest: 'AI-arbeidsflyt',
    platformRequest: 'Plattform',
    aiPrompt: 'Prompt',
    aiSummary: 'AI-sammendrag',
    openInGenerator: 'Apne i generator',
    noRequests: 'Ingen ventende foresporsler',
    filterAll: 'Alle',
    filterPending: 'Ventende',
    filterApproved: 'Godkjent',
    filterDenied: 'Avslått',
    environmentUrl: 'Miljø-URL',
    reviewedBy: 'Vurdert av',
    reviewNote: 'Merknad',
    requestedTier: 'Forespurt tier',
    description: {
      mcp: 'MCP: %{server}',
      platform: 'Tier-oppgradering: %{tier}',
    },
  },
  filters: {
    title: 'Filtre',
    show: 'Vis filtre',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    deleted: 'Slettet',
    marketplace: 'Markedsplass',
    marketplaceVisible: 'Synlig',
    marketplaceHidden: 'Ikke synlig',
    toolSource: 'Verktøykilde',
    application: 'Applikasjon',
    authType: 'Autentiseringstype',
    tier: 'Tier',
    tierFree: 'Free',
    tierTeam: 'Team',
    tierEnterprise: 'Enterprise',
    tierNone: 'Ingen',
    scope: 'Omfang',
  },
  mcp: {
    list: {
      cost: 'Kostnad / 1k kall',
      costPer1k: '/ 1k',
      links: 'Koblinger',
      requests24h: 'Siste 24t',
    },
  },
  workflow: {
    title: 'Arbeidsflyt-editor',
    untitled: 'Navnløs arbeidsflyt',
    loading: 'Laster...',
    create: {
      nameDialogTitle: 'Gi arbeidsflyten et navn',
      nameLabel: 'Visningsnavn',
    },
    variables: {
      title: 'Variabler',
      subtitle: 'Automatisk oppdaget fra {{ variables.X }}-referanser i arbeidsflyt-nodene.',
      emptyHelp: 'Ingen variabler ennå — referer til {{ variables.<navn> }} i en node-parameter, så vises den her.',
    },
    costPerWorkflowExecution: 'Kostnad per kjøring (EUR)',
    costPerWorkflowExecutionHelp: 'Overstyring for denne arbeidsflyten. La stå tomt for å arve fra organisasjonen eller portal-standarden.',
    sidebar: {
      search: 'Søk noder...',
      triggers: 'Utløsere',
      mcpTools: 'MCP-verktøy',
      logic: 'Logikk',
      data: 'Data',
      ai: 'AI',
    },
    nodes: {
      trigger: 'Utløser',
      toolCall: 'MCP-verktøykall',
      aiCall: 'AI-kall',
      aiCallDesc: 'Kall en LLM-modell',
      condition: 'Betingelse',
      loop: 'Løkke',
      transform: 'Transformasjon',
      fieldMapping: 'Feltmapping',
      fieldMappingDesc: 'Deklarativ felt-for-felt mapping med transformasjoner',
      merge: 'Sammenslåing',
      cron: 'Cron-plan',
      webhook: 'Webhook',
      manual: 'Manuell start',
      mcpTrigger: 'MCP Tool',
      cronDesc: 'Gjentakende plan',
      webhookDesc: 'HTTP tilbakeringing',
      manualDesc: 'Kjor manuelt',
      mcpTriggerDesc: 'Tilgjengelig som MCP-verktøy for AI-klienter',
      conditionDesc: 'Hvis/ellers forgrening',
      loopDesc: 'Iterer over elementer',
      mergeDesc: 'Vent pa forgreninger',
      transformDesc: 'Kartlegg og transformer data',
      visualization: 'Visualisering',
      visualizationDesc: 'Vis data som tabell eller diagram',
      data: 'Datakilde',
      dataDesc: 'Les et utdrag fra et lenkevedlegg (XML/JSON)',
      parse: 'Parse',
      parseDesc: 'Kjør en registrert parser (f.eks. iNavigator → Zaken payload)',
      mcp: 'MCP-verktøy',
      dataStoreWrite: 'Datalager: lagre',
      dataStoreWriteDesc: 'Lagre en verdi (vektor eller plain) under en identifikator for senere oppslag',
      dataStoreRead: 'Datalager: les',
      dataStoreReadDesc: 'Les en verdi fra datalageret (semantisk eller på nøkkel)',
      dataStoreUpdate: 'Datalager: oppdater',
      dataStoreUpdateDesc: 'Erstatt innhold + metadata for en eksisterende vektor-post via id',
      dataStoreDelete: 'Datalager: slett',
      dataStoreDeleteDesc: 'Fjern en vektor-post via id (idempotent)',
      dataStore: 'Datalager',
      // eslint-disable-next-line max-len
      dataStoreDesc: 'Les, lagre, oppdater eller slett oppføringer i det semantiske datalageret (velg operasjon i node-konfigurasjonen).',
      tested: 'Testet',
    },
    config: {
      title: 'Node-konfigurasjon',
      fm: {
        inputSource: 'Kilde',
        inputSourceHelp: 'Sti som "nodes.data-1" eller "trigger" — dicten å mappe fra.',
        mappings: 'Mappinger',
        addMapping: 'Legg til mapping',
        noMappings: 'Ingen mappinger ennå — legg til én for å trekke ut felter.',
        from: 'Fra',
        to: 'Til',
        transform: 'Transformasjon',
        required: 'Påkrevd',
        maxLength: 'Maks lengde',
        defaultValue: 'Standardverdi',
        lookupTable: 'Oppslagstabell (JSON)',
        lookupTableHelp: 'Map kildeverdier til målverdier, f.eks. {"Jaar":"year"}.',
        regexPattern: 'Regex-mønster',
        regexReplacement: 'Erstatning',
        transformNone: 'Ingen transformasjon',
        transformUppercase: 'STORE BOKSTAVER',
        transformLowercase: 'små bokstaver',
        transformTrim: 'Fjern mellomrom',
        transformTruncate: 'Avkort',
        transformDefault: 'Standard hvis tom',
        transformLookup: 'Oppslagstabell',
        transformToNumber: 'Til tall',
        transformToBoolean: 'Til boolean',
        transformRegexReplace: 'Regex erstatt',
      },
      label: 'Etikett',
      server: 'MCP-server',
      tool: 'Verktøy',
      parameters: 'Parametere',
      expression: 'Uttrykk',
      assertTruthy: 'Stopp arbeidsflyten når denne betingelsen er usann',
      assertTruthyHelp: 'Når aktivert vil et usant resultat stoppe arbeidsflyten og returnere feilmeldingen nedenfor til MCP-anroperen.',
      assertError: 'Feilmelding',
      assertErrorPlaceholder: 'F.eks. Ingen person funnet med dette navnet',
      cronExpression: 'Cron-uttrykk',
      webhookPath: 'Webhook-sti',
      attachmentRole: 'Vedleggsrolle',
      attachmentRoleHelp: 'Unikt navn som source_xml',
      attachmentRoleRequired: 'Denne data-noden kan ikke kjøres før den har en vedleggsrolle.',
      attachmentLabel: 'Vedleggsetikett',
      attachmentLabelHelp: 'Hva kunden ser ved opplasting, f.eks. i-Navigator DSP-export',
      attachmentDescription: 'Vedleggsbeskrivelse',
      attachmentDescriptionHelp: 'Valgfri forklaring ved opplastingsfeltet',
      attachmentFormatHint: 'Vedleggsformat-hint',
      attachmentFormatHintHelp: 'MIME- eller format-hint, f.eks. application/xml',
      format: 'Format',
      selector: 'Selektor',
      selectorHelp: 'XPath (XML) eller dotted path (JSON). Støtter {{ uttrykk }}.',
      sourceExpression: 'Kilde-uttrykk',
      // eslint-disable-next-line max-len
      sourceExpressionHelp: 'Hva som vises. La stå tomt for hele utdataen fra forrige node, eller pek på en del, f.eks. {{ nodes.get-casetype.output.data }}.',
      // eslint-disable-next-line max-len
      mcpHelp: 'Workflows med en MCP-trigger eksponeres som verktøy på /api/v1/mcp/workflows. Legg til denne URL-en som en MCP-server i Claude Desktop.',
      arrayExpression: 'Array-uttrykk',
      itemVariable: 'Elementvariabel',
      loopLogChildren: 'Logg hver body-node per iterasjon',
      // eslint-disable-next-line max-len
      loopLogChildrenHelp: 'Når på, lagres hver node i loop-body som et eget execution-step. Standard av slik at en stor loop (f.eks. CSV-import) ikke oversvømmer step-visningen. Slå på for små gating-loops der du vil ha full synlighet.',
      trueLabel: 'Sann',
      falseLabel: 'Usann',
      perItem: 'Per element',
      mergeStrategy: 'Sammenslåingsstrategi',
      waitAll: 'Vent på alle',
      firstResult: 'Første resultat',
      deleteNode: 'Slett node',
      fieldMapping: 'Felttilordning',
      paramJsonHelp: 'Send denne parameteren som JSON (objekt, array, boolsk eller tall) i stedet for tekst',
      paramJsonInvalid: 'Ugyldig JSON — verdien lagres ikke før den er gyldig',
      paramJsonFormat: 'Formater JSON',
      paramNoDescription: 'Ingen beskrivelse — type: %{type}',
      paramSourceFixed: 'Fast',
      paramSourceExpression: 'Uttrykk',
      insertExpressionHelp: 'Sett inn et uttrykk — referer til data fra triggeren eller tidligere noder',
      optionalFields: 'Valgfrie felt (%{smart_count})',
      // eslint-disable-next-line max-len
      paramsRemoved: '%{smart_count} parameter fjernet — det valgte verktøyet støtter den ikke. |||| %{smart_count} parametere fjernet — det valgte verktøyet støtter dem ikke.',
      toolEmptyState: 'Velg en MCP-server og et verktøy for å konfigurere dette steget.',
      toolDisabledSuffix: 'deaktivert',
      // eslint-disable-next-line max-len
      toolDisabledWarning: 'Det valgte verktøyet er deaktivert på MCP-serveren. Aktiver det på serveren eller velg et annet — dette steget feiler så lenge verktøyet er deaktivert.',
      // eslint-disable-next-line max-len
      inputDataEmpty: 'Ingen inndata kjent ennå. Kjør en vellykket test på en tidligere node for å se feltene her.',
      inputDataHint: 'Klikk på et felt for å sette det inn i det sist valgte parameterfeltet.',
      inputDataFromTrigger: 'trigger-inndata',
      inputDataFromTest: 'fra testresultat',
      inputDataFromAi: 'fra forventet utgang',
      inputDataInserted: 'Satt inn',
      inputDataCopied: 'Kopiert — klikk først på et parameterfelt for å sette inn direkte',
      outputExample: 'Forventet JSON-utgang (eksempel)',
      // eslint-disable-next-line max-len
      outputExampleHint: 'Eksempel på JSON-objektet KI-en skal returnere. Legges bak prompten som et strukturhint; nøklene blir tilgjengelige for senere noder som {{ nodes.<id>.output.felt }}.',
      paramsNotInSchema: 'Ikke i verktøyskjema',
      paramsNotInSchemaHint: 'Lagret på noden og sendes ved hver kjøring, men verktøyet kjenner dem ikke. Rediger eller fjern dem.',
      paramNotInSchemaType: 'lagret',
      paramRemove: 'Fjern parameter',
      paramRequired: 'Obligatorisk parameter',
      testCall: 'Testkall',
      aiModel: 'Modell',
      systemPrompt: 'Systemprompt',
      systemPromptPlaceholder: 'Du er en hjelpsom assistent...',
      userPrompt: 'Brukerprompt',
      userPromptPlaceholder: 'Bruk {{ uttrykk }} for å referere til data fra tidligere noder',
      inputData: 'Inngangsdata',
      expectJson: 'Forvent JSON-utgang',
      temperature: 'Temperatur',
      parser: 'Parser',
      parserPlaceholder: 'Velg en registrert parser...',
      // eslint-disable-next-line max-len
      parserNoneEnabled: 'Ingen parsere er aktivert i denne deployen. Sett ENABLED_PARSERS i API-konfigen.',
      parserMode: 'Modus',
      parserModeParse: 'Parse',
      parserModeRequirements: 'Requirements (tørrkjøring)',
      parserInputSource: 'Inngangskilde',
      // eslint-disable-next-line max-len
      parserInputSourceHelp: 'Stiuttrykk som løses mot konteksten. Peker vanligvis på upstream data-noden, f.eks. {{ inavigator_xml.match }}.',
      parserExtra: 'Ekstra inputs',
      // eslint-disable-next-line max-len
      parserExtraHelp: 'Løses per kall og sendes til parseren. Bruk dette for å injisere UUIDer fra tidligere tool_calls (f.eks. catalog_folder_uuid).',
      parserExtraKeyPlaceholder: 'ekstra nøkkel, f.eks. catalog_folder_uuid',
      mcpToolName: 'MCP-verktøynavn',
      mcpToolNameHelp: 'Lowercase, snake_case. Dette er det Claude Desktop kaller.',
      mcpToolDescription: 'MCP-verktøybeskrivelse',
      // eslint-disable-next-line max-len
      mcpToolDescriptionPlaceholder: 'Hva gjør dette verktøyet? Når skal assistenten bruke det?',
      mcpToolDescriptionHelp: 'Vises for assistenten i tools/list. Vær spesifikk.',
      mcpToolInputSchema: 'Inngangs-skjema',
      // eslint-disable-next-line max-len
      mcpToolInputSchemaHelp: 'JSON Schema som beskriver argumentene verktøyet tar. Valideres ved blur.',
      mcpSchemaModeFields: 'Felter',
      mcpSchemaFieldName: 'navn',
      mcpSchemaFieldType: 'type',
      mcpSchemaNoFields: 'Ingen felter ennå — klikk "+ Legg til felt" for å definere et.',
      mcpSchemaAddField: 'Legg til felt',
      mcpSchemaRequired: 'påkrevd',
      mcpSchemaFieldDescription: 'Beskrivelse (vises til den kallende AI-en)',
      mcpSchemaMinLength: 'minLength',
      mcpSchemaMaxLength: 'maxLength',
      mcpSchemaFormat: 'format',
      mcpSchemaMin: 'min',
      mcpSchemaMax: 'max',
      mcpSchemaMinItems: 'minItems',
      mcpSchemaMaxItems: 'maxItems',
      mcpSchemaArrayItems: 'Array-element-skjema',
      mcpSchemaJsonNotAnObject: 'Toppnivå-skjemaet må være et JSON-objekt — fikk en annen type.',
      mcpSchemaNameCollision: 'Et felt med dette navnet finnes allerede.',
      mcpSchemaNameEmpty: 'Feltnavn kan ikke være tomt.',
      dataStoreMode: 'Lagringsmodus',
      dataStoreModeVector: 'Vektor (semantisk)',
      dataStoreModePlain: 'Plain (nøkkel/verdi)',
      // eslint-disable-next-line max-len
      dataStoreModeVectorHelp: 'Lagres i pgvector og embeddes ved lagring. Lesing returnerer nærmeste treff på betydning.',
      // eslint-disable-next-line max-len
      dataStoreModePlainHelp: 'Lagres i Redis som identifikator+nøkkel → verdi. Ingen embedding-kostnad, eksakt-treff lesing.',
      // eslint-disable-next-line max-len
      dataStoreReadVectorHelp: 'Semantisk søk i tidligere lagret innhold. Tregere; returnerer nærmeste treff på betydning.',
      // eslint-disable-next-line max-len
      dataStoreReadPlainHelp: 'Eksakt oppslag på nøkkel. La nøkkel være tom for å returnere alle oppføringer under identifikatoren.',
      dataStoreIdentifier: 'Identifikator',
      // eslint-disable-next-line max-len
      dataStoreIdentifierHelp: 'Samlingsnavn. Workflows med samme identifikator deler samme dataslice (per organisasjon).',
      dataStoreKey: 'Nøkkel',
      dataStoreKeyHelp: 'Påkrevd for plain-modus. Blir Redis hash-feltnavn.',
      dataStoreReadKeyHelp: 'Nøkkel å slå opp. La være tom for å hente alle oppføringer under denne identifikatoren.',
      dataStoreKeyword: 'Nøkkelord-filter',
      // eslint-disable-next-line max-len
      dataStoreKeywordHelp: 'Valgfri delstreng-match på innhold, nøkkel og metadata. Koble til et MCP-argument (f.eks. {{ trigger.keyword }}) slik at assistenten kan søke i samlingen.',
      // eslint-disable-next-line max-len
      csvHelp: 'CSV parses til en liste med rader. Bruk en Loop-node nedstrøms (arrayExpression: nodes.<id>.rows) og referer kolonner via {{ item.<header> }}.',
      autocompleteFunctionsLoadFailed:
        'Listen med funksjoner kunne ikke lastes. Last editoren på nytt — økten kan ha utløpt.',
      dataStoreOperation: 'Operasjon',
      dataStoreOpRead: 'Les',
      dataStoreOpWrite: 'Lagre',
      dataStoreOpUpdate: 'Oppdater',
      dataStoreOpDelete: 'Slett',
      dataStoreContent: 'Innhold som skal lagres',
      dataStoreValue: 'Verdi som skal lagres',
      dataStoreRecordId: 'Post-id',
      // eslint-disable-next-line max-len
      dataStoreRecordIdHelp: 'UUID for posten som skal oppdateres eller slettes. Vanligvis bundet til {{ trigger.id }} når den kalles som MCP-verktøy.',
      // eslint-disable-next-line max-len
      dataStoreContentHelp: 'Fritekst eller {{ nodes.x.output }}-referanse. Embeddes automatisk ved lagring.',
      // eslint-disable-next-line max-len
      dataStoreValueHelp: 'Fritekst eller {{ nodes.x.output }}-referanse. Lagres ordrett i Redis.',
      dataStoreMetadata: 'Metadata (valgfritt)',
      dataStoreMetadataHelp: 'Nøkkel/verdi-par som lagres på posten. Verdier kan referere upstream noder.',
      dataStoreQuery: 'Søkespørring',
      // eslint-disable-next-line max-len
      dataStoreQueryHelp: 'Naturlig språk-spørsmål. De nærmeste treffene (cosine similarity) returneres i hits[].',
      dataStoreTopK: 'Antall treff',
      dataStoreTopKHelp: 'Hvor mange poster å returnere (1-50). Lavere = raskere.',
    },
    node: {
      missingAttachmentRoleSubtitle: 'Manglende vedleggsrolle',
      missingAttachmentRoleWarning: 'Konfigurer en vedleggsrolle før du lagrer denne workflowen.',
      dataStoreMissingIdentifier: 'Manglende identifikator',
      dataStoreMissingContent: 'Manglende innhold',
      dataStoreMissingKey: 'Manglende nøkkel',
      dataStoreMissingQuery: 'Manglende søk',
      dataStoreMissingRecordId: 'Manglende post-id',
      dataStoreUpdateSummary: 'Oppdaterer post',
      dataStoreDeleteSummary: 'Sletter post',
      dataStoreDeletePlainSummary: 'Slett (plain) fra',
      dataStoreWriteVectorSummary: 'Lagrer (vektor) i',
      dataStoreWritePlainSummary: 'Lagrer (plain) i',
      dataStoreReadVectorSummary: 'Søker (vektor) i',
      dataStoreReadPlainSummary: 'Leser (plain) fra',
      dataStoreReadAll: 'alle oppføringer',
    },
    actions: {
      autoLayout: 'Auto-oppsett',
      undo: 'Angre',
      executions: 'Utforelser',
      editFlow: 'Rediger flyt',
    },
    details: {
      name: 'Navn',
      about: 'Om',
      triggerType: 'Utlosertype',
      nodeCount: 'Noder',
      edgeCount: 'Kanter',
      autoApprove: 'Automatisk godkjenning',
    },
    list: {
      cost: 'Kostnad / kjøring',
      costPortalDefault: '(portal-standard)',
      costNotSet: 'Ikke satt',
      links: 'Koblinger',
      executions24h: 'Siste 24t',
      triggerType: 'Utløser',
    },
    stat: {
      executions24h: 'Kjøringer · siste 24t',
      executionsTotal: 'Kjøringer · totalt',
      executionsSuccessful: 'Vellykkede kjøringer',
      executionsFailed: 'Feilede kjøringer',
      links: 'Koblinger',
      successRate: 'Suksessrate',
      successRateNoData: 'Suksessrate (ingen data)',
      successRateTitle: 'Helse',
    },
    filters: {
      trigger: 'Utløser',
      triggerManual: 'Manuell',
      triggerCron: 'Cron',
      triggerWebhook: 'Webhook',
      triggerMcp: 'MCP-verktøy',
    },
    tabs: {
      details: 'Detaljer',
      links: 'Koblinger',
      executions: 'Utforelser',
      noExecutions: 'Ingen utforelser enna.',
    },
    test: {
      title: 'Test',
      organization: 'Organisasjon',
      seat: 'Bruker (valgfritt)',
      noSeat: 'Standard (admin)',
      environment: 'Miljo',
      defaultEnvironment: 'Standard',
      execute: 'Utfor',
      success: 'Suksess',
      failed: 'Mislyktes',
      availableFields: 'Tilgjengelige felt (klikk for a kopiere sti)',
      copied: 'Kopiert!',
      orgHelp: 'Bestemmer hvilken organisasjons kobling og data testen bruker.',
      // eslint-disable-next-line max-len
      seededFromExpression: 'I arbeidsflyten fylles dette av %{expression} — angi en konkret testverdi.',
      invalidJson: 'Ugyldig JSON',
      omitValue: 'Utelat',
      errorAuth: 'Ingen tilgang — kontroller koblingen (autentisering) for denne organisasjonen.',
      errorForbidden: 'Tilgang nektet — denne brukeren eller koblingen kan ikke utføre denne handlingen.',
      errorNotFound: 'Ikke funnet — objektet eller endepunktet finnes ikke i målsystemet.',
      // eslint-disable-next-line max-len
      errorValidation: 'Parametrene samsvarer ikke med det verktøyet forventer — sjekk obligatoriske felt og typer.',
      errorUpstream: 'Den bakenforliggende serveren ga en feil — prøv igjen eller sjekk målsystemet.',
      errorNetwork: 'Den bakenforliggende serveren er ikke tilgjengelig — sjekk base-URL og tilkobling.',
      errorDetails: 'Detaljer',
    },
    execution: {
      workflow: 'Arbeidsflyt',
      organization: 'Organisasjon',
      status: 'Status',
      trigger: 'Utloser',
      triggeredBy: 'Startet av',
      started: 'Startet',
      finished: 'Fullfort',
      duration: 'Varighet',
      stepsCount: 'Trinn',
      steps: 'Trinn',
      error: 'Feil',
      filterStatus: 'Status',
      completed: 'Fullfort',
      running: 'Kjorer',
      failed: 'Mislyktes',
      pending: 'Venter',
      success: 'Suksess',
      skipped: 'Hoppet over',
      deleteTitle: 'Slett utforelse?',
      deleteContent: 'Denne utforelsen og alle trinn blir permanent slettet.',
    },
    ai: {
      button: 'Generer med AI',
      title: 'AI-arbeidsflytgenerator',
      intro:
        'Beskriv hva arbeidsflyten skal gjore — inkludert utloseren, stegene og hva som skjer med resultatet.'
        + ' Assistenten stiller oppfolgingssporsmal hvis noe er uklart.',
      descriptionLabel: 'Beskriv arbeidsflyten',
      descriptionPlaceholder:
        'Hver hverdag klokken 9:00 hentes apne Topdesk-saker, oppsummeres med en LLM'
        + ' og legges ut i #service-desk pa Slack.',
      submit: 'Fortsett',
      analyzing: 'Analyserer beskrivelsen…',
      needsMoreInfo: 'Jeg trenger litt mer informasjon',
      answerLabel: 'Legg til detaljene som mangler',
      answerPlaceholder: 'Oppgi den manglende informasjonen…',
      summaryTitle: 'Dette kommer jeg til a bygge',
      summaryHint: 'Bekreft beskrivelsen nedenfor eller juster den for du bygger.',
      build: 'Bygg arbeidsflyt',
      edit: 'Juster beskrivelsen',
      building: 'Bygger arbeidsflyten…',
      successTitle: 'Arbeidsflyt klar',
      successMessage: 'Apne arbeidsflyten for a gjennomga og forbedre den.',
      openWorkflow: 'Apne arbeidsflyt',
      errorTitle: 'Noe gikk galt',
      errorBody: 'Assistenten klarte ikke a generere arbeidsflyten.',
      retry: 'Prov igjen',
    },
    doctor: {
      title: 'AI Doctor',
      intro:
        'Korselen feilet. La AI undersoke sporet og foresla en konkret losning du kan bruke.',
      start: 'Start diagnose',
      analyzing: 'AI analyserer feilen…',
      cached: '(fra cache)',
      explanation: 'Forklaring',
      suggestedFix: 'Foreslatt losning',
      suggestedInputs: 'Foreslatt input',
      rootCause: 'Hovedarsak',
      refresh: 'Ny diagnose',
      retryWithFix: 'Prov pa nytt med fiks',
      retryStarted: 'Ny korsel startet.',
    },
    copilot: {
      title: 'AI Co-pilot',
      tagline: 'Endre arbeidsflyten med AI',
      toggle: 'AI Co-pilot',
      intro:
        'Beskriv hva du vil endre. Co-piloten foreslar en endring du kan se gjennom for du bruker den.',
      try: 'Prov en prompt',
      suggestRetry: 'Legg til en retry pa det feilende tool call',
      suggestSummary: 'Sett inn et AI-trinn som oppsummerer forrige utdata',
      suggestParallel: 'Kjor de to tool call-ene parallelt og merge resultatet',
      placeholder: 'Beskriv en endring…',
      send: 'Send',
      thinking: 'AI tenker…',
      you: 'Du',
      assistant: 'Co-pilot',
      pendingDiff: 'Foreslatt endring',
      apply: 'Bruk',
      discard: 'Avvis',
      diffAdd: 'Legg til',
      diffUpdate: 'Endre',
      diffRemove: 'Fjern',
    },
    editor: {
      unsavedTitle: 'Ulagrede endringer',
      // eslint-disable-next-line max-len
      unsavedBody: 'Du har ulagrede endringer i denne arbeidsflyten. Hvis du forlater siden går de tapt.',
      unsavedStay: 'Fortsett å redigere',
      unsavedLeave: 'Forlat uten å lagre',
    },
    validation: {
      title: 'Denne arbeidsflyten har problemer',
      description: 'Løs problemene under før du lagrer, eller bruk "Lagre likevel" hvis du vet hva du gjør.',
      errorCount: '%{count} feil |||| %{count} feil',
      warningCount: '%{count} advarsel |||| %{count} advarsler',
      cancel: 'Løs problemene',
      saveAnyway: 'Lagre likevel',
      saveAnywayConfirm: 'Lagring beholder de uløste referansene. De vil bli til en tom streng under kjøring. Fortsette?',
      jumpToNode: 'Gå til node',
      registryUnavailable: 'Kunne ikke verifisere funksjonsnavn — registeret er utilgjengelig.',
      unclosedBraces: 'Ulukket uttrykk — legg til `}}` for å lukke `{{`.',
      emptyExpression: 'Tomt uttrykk — skriv noe mellom `{{` og `}}`.',
      emptySegment: 'Tomt stisegment — fjern det ekstra punktumet.',
      unknownRoot: 'Ukjent rot `%{root}` — bruk `functions`, `variables`, `trigger` eller `nodes`.',
      unknownFunction: 'Ukjent funksjon `functions.%{name}` — sjekk stavemåten.',
      malformedFunctionCall: 'Funksjonskall trenger parenteser — skriv `functions.<navn>(...)`.',
      unknownNode: 'Ingen node med navn `%{id}` i denne arbeidsflyten.',
      nodeNotReachable: 'Node `%{id}` er ikke en forgjenger av denne noden — vil bli en tom streng under kjøring.',
      unknownTriggerKey: 'Trigger har ingen felt `%{key}`.',
      unknownVariable: 'Variabel `%{name}` brukes ikke andre steder ennå — opprettes ved lagring.',
    },
  },
}
